import './InlineEdit.scss';

import { SchemaProperty } from '@amzn/awscat-portfolio-assessment-types';
import { Button, Popover } from '@amzn/awsui-components-react';
import { useContext, useRef, useState } from 'react';

import { InlineEditContext, InlineEditRowItem } from './InlineEditContext';
import InlineEditModal from './InlineEditModal';
type Props = {
    displayValue: string | number;
    column: string;
    schemaProperty: SchemaProperty;
    originalValue: string | number | boolean;
    rowItem: InlineEditRowItem;
}

const TableCell = (props: Props): JSX.Element => {
    const [ showPopover, setShowPopover ] = useState(false);
    const { pauseMouseAction, updatePauseMouseAction } = useContext(InlineEditContext);
    const wrapperRef = useRef<HTMLDivElement>(null);

    const handleClickOutside = (evt: Event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(evt.target as HTMLDivElement)) {
            closePopover();
        }
    };

    const closePopover = () => {
        document.removeEventListener('mousedown', handleClickOutside);
        setShowPopover(false);
        updatePauseMouseAction(false);
    };

    const openPopover = () => {
        document.addEventListener('mousedown', handleClickOutside);
        updatePauseMouseAction(true);
    };

    const mouseOver = () => {
        if (pauseMouseAction) {
            return;
        }
        setShowPopover(true);
    };

    const mouseOut = () => {
        if (pauseMouseAction) {
            return;
        }
        setShowPopover(false);
    };

    return (
        <div onMouseEnter={mouseOver} onMouseLeave={mouseOut} ref={wrapperRef} className='inline-edit-table-cell'>
            {props.displayValue}&nbsp;
            {showPopover && (
                <Popover   
                    dismissButton={false}
                    position='top'
                    size='large'
                    triggerType='custom'
                    content={
                        <InlineEditModal
                            originalValue={props.originalValue}
                            cancelEdit={closePopover}
                            schemaProperty={props.schemaProperty}
                            columnId={props.column}
                            rowItem={props.rowItem}
                        />
                    }
                    className='inline-btn'
                >
                    <Button iconName='edit' variant='icon' onClick={openPopover} />
                </Popover>
            )}
        </div>
    );
};

export default TableCell;
